import { useProfileStore } from '@stores/profile'

interface CustomerPrivilegesReturn {
  canViewCustomers: ComputedRef<boolean>
  canManageCustomers: ComputedRef<boolean>
  canDeleteCustomers: ComputedRef<boolean>
  canManageKids: ComputedRef<boolean>
  canSimpleViewDisciplines: ComputedRef<boolean>
  canViewOrders: ComputedRef<boolean>
  canViewSubscriptions: ComputedRef<boolean>
  canManageSubscriptions: ComputedRef<boolean>
}

export const useCustomerPrivileges = (): CustomerPrivilegesReturn => {
  const profileStore = useProfileStore()

  const hasPrivilege = (key: string): ComputedRef<boolean> =>
    computed<boolean>(() => profileStore.privileges?.includes(key) ?? false)

  return {
    canViewCustomers: hasPrivilege('view-customers'),
    canManageCustomers: hasPrivilege('manage-customers'),
    canDeleteCustomers: hasPrivilege('delete-customers'),
    canManageKids: hasPrivilege('manage-kids'),
    canSimpleViewDisciplines: hasPrivilege('simple-view-disciplines'),
    canViewOrders: hasPrivilege('view-orders'),
    canViewSubscriptions: hasPrivilege('view-subscriptions'),
    canManageSubscriptions: hasPrivilege('manage-subscriptions'),
  }
}
